export var ConfigType;
(function (ConfigType) {
    ConfigType["TAG"] = "tag";
    ConfigType["SKIN"] = "skin";
})(ConfigType || (ConfigType = {}));
